"use client";
import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLHeadingElement>(null);

  useGSAP(() => {
    const section = sectionRef.current;
    const textEl = textRef.current;

    if (!section || !textEl) return;

    // Scroll Pin
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom 50%",
      pin: true,
      scrub: true,
      markers:false,
    });

    const chars = textEl.querySelectorAll("span");

    gsap.from(chars, {
      opacity: 0,
      y: 50,
      stagger: 0.05,
      ease: "power3.out",
      duration: 1,
    });
  }, { scope: sectionRef });

  const splitText = (text: string) => {
    return text.split("").map((char, index) => (
      <span key={index} className="inline-block">
        {char === " " ? "\u00A0" : char}
      </span>
    ));
  };

  return (
    <section
      className="relative h-screen w-full flex items-center justify-center overflow-hidden before:absolute before:inset-0 before:bg-black/30 before:z-10 custome-clippath"
      ref={sectionRef}
    >
      <video
        src="https://alstoneindia.com/emergev2/video/banner-video.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative z-20 px-4 w-full flex justify-center">
        <h1
          ref={textRef}
          className="text-white text-[clamp(1.7rem,5vw,4rem)] font-bold flex flex-wrap justify-center gap-[2px] max-w-[90%] text-center"
        >
          {splitText("Excellence in Glass")}
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
